import { Color } from 'csstype'
import { useServerTime } from 'hooks/useServerTime'
import { calculateAge } from 'util/date/calculateAge'
import { CidadaoListagemSaudeMulherQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { AcompanhamentoCondicaoSaudeVacinasSection } from '../AcompanhamentoCondicaoSaudeVacinasSection'
import { GRUPOS_IMUNOBILIOGICO_SAUDE_MULHER } from '../model-acompanhamentoCondicaoSaudeAccordion'
import { RastreamentoAcompanhamentoIstPanel } from './RastreamentoAcompanhamentoIstPanel'
import { RastreamentoCancerColoUteroPanel } from './RastreamentoCancerColoUteroPanel'
import { RastreamentoCancerDeMamaPanel } from './RastreamentoCancerDeMamaPanel'
import { UltimaConsultaSaudeSexualReprodutivaPanel } from './UltimaConsultaSaudeSexualReprodutiva'

interface AcompanhamentoCondicaoSaudeMulherAccordionSectionProps {
  row: CidadaoListagemSaudeMulherQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeMulherAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeMulherAccordionSectionProps>
) {
  const { row, iconColor } = props
  const { getServerTimeNow } = useServerTime()

  const saudeDaMulher = row.cidadao.cidadaoConsolidado?.saudeMulher
  const { years: idadeCidadao } = calculateAge(row.dataNascimentoCidadao, getServerTimeNow().getTime())

  return (
    <>
      <UltimaConsultaSaudeSexualReprodutivaPanel
        data={saudeDaMulher?.ultimaConsulta?.iniciadoEm}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <RastreamentoAcompanhamentoIstPanel
        hiv={saudeDaMulher?.hiv}
        sifilis={saudeDaMulher?.sifilis}
        hepatiteB={saudeDaMulher?.hepatiteB}
        hepatiteC={saudeDaMulher?.hepatiteC}
        iconColor={iconColor}
      />
      <RastreamentoCancerColoUteroPanel
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerColoUtero}
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerColoUtero}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <RastreamentoCancerDeMamaPanel
        ultimaAvaliacao={saudeDaMulher?.ultimaAvaliacaoCancerMama}
        ultimaRealizacao={saudeDaMulher?.ultimaRealizacaoCancerMama}
        ultimaSolicitacao={saudeDaMulher?.ultimaSolicitacaoCancerMama}
        idadeCidadao={idadeCidadao}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVacinasSection
        vacinas={saudeDaMulher?.vacinasAplicadas}
        grupos={GRUPOS_IMUNOBILIOGICO_SAUDE_MULHER}
        iconColor={iconColor}
      />
    </>
  )
}
